import { isIgnoredErrorMessage } from './lib/ignoredErrors'

const isChunkLoadError = (message: string | null | undefined): boolean => {
  if (!message) {
    return false
  }

  return (
    message.includes('Failed to fetch dynamically imported module') ||
    message.includes('Importing a module script failed') ||
    message.includes('error loading dynamically imported module')
  )
}

const getErrorMessage = (error: unknown): string | null => {
  if (!error) {
    return null
  }
  if (error instanceof Error) {
    return error.message
  }
  if (
    typeof error === 'object' &&
    'message' in error &&
    typeof (error as { message: unknown }).message === 'string'
  ) {
    return (error as { message: string }).message
  }
  return String(error)
}

const handleChunkLoadError = (): void => {
  try {
    const lastReload = globalThis.sessionStorage?.getItem(
      'chunk_load_reload_timestamp',
    )
    const now = Date.now()

    // If we reloaded less than 10 seconds ago, do not reload again to avoid an infinite loop.
    if (lastReload && now - Number.parseInt(lastReload, 10) < 10000) {
      console.error(
        'Chunk load error occurred, but page was reloaded recently. Stopping reload loop.',
      )
      return
    }

    globalThis.sessionStorage?.setItem(
      'chunk_load_reload_timestamp',
      String(now),
    )
    globalThis.location.reload()
  } catch (err) {
    console.error('Failed to handle chunk load error', err)
    try {
      globalThis.location.reload()
    } catch (reloadErr) {
      console.error('Failed to reload page', reloadErr)
    }
  }
}

globalThis.addEventListener(
  'error',
  (e) => {
    if (isIgnoredErrorMessage(e.message)) {
      e.stopImmediatePropagation()
      e.preventDefault()
      return
    }

    if (isChunkLoadError(e.message)) {
      e.stopImmediatePropagation()
      handleChunkLoadError()
    }
  },
  { capture: true },
)

globalThis.addEventListener(
  'unhandledrejection',
  (e) => {
    const message = getErrorMessage(e.reason)
    if (isIgnoredErrorMessage(message)) {
      e.stopImmediatePropagation()
      e.preventDefault()
      return
    }

    if (isChunkLoadError(message)) {
      e.stopImmediatePropagation()
      handleChunkLoadError()
    }
  },
  { capture: true },
)

globalThis.addEventListener('vite:preloadError', () => {
  handleChunkLoadError()
})
